import { render, staticRenderFns } from "./psychologyRoomDialog.vue?vue&type=template&id=1d8b86c7&"
import script from "./psychologyRoomDialog.vue?vue&type=script&lang=js&"
export * from "./psychologyRoomDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports